<template>
  <div
    :id="id"
    class="chart"
  />
</template>

<script>
import * as echarts from 'echarts';
// import resize from './mixins/resize'

export default {
  // mixins: [resize],
  props: {
    id: {
      type: String,
      default: 'id'
    },
    title: {
      type: String,
      default: '全厂'
    },
    showLegend: {
      type: Boolean,
      default: false
    },
    dataList: {
      type: Array,
      default: function () {
        return []
      }
    },
  },
  data() {
    return {
      chart: null,
      screenWidth: window.screen.width == 960? 5 : window.screen.width == 1280 || Math.floor(window.screen.width * window.devicePixelRatio) == 3840 ? 8 : 12,
      w960: window.screen.width == 960? true : false,
      titleSize: window.screen.width == 960? 6 : window.screen.width == 1280 || Math.floor(window.screen.width * window.devicePixelRatio) == 3840 ? 8 : 12,
    }
  },
  mounted() {
  },
  beforeDestroy() {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart(dataList) {
      if (!this.chart) this.chart = echarts.init(document.getElementById(this.id))
      const gaugeData = [
        {
          value: dataList[0],
          name: '实时',
          title: {
            show: false,
            offsetCenter: ['0%', '-30%'],
            fontSize: 13,
            borderWidth: 0,
            color: '#fff',
          },
          itemStyle: {
            color: '#fec200'
          },
          detail: {
            offsetCenter: ['0%', '-30%'],
          }
        },
        {
          value: dataList[1],
          name: '日平均',
          title: {
            show: false,
            offsetCenter: ['0%', '0%'],
            fontSize: 13,
            borderWidth: 0,
            color: '#fff',
          },
          itemStyle: {
            color: '#17c5fd'
          },
          detail: {
            offsetCenter: ['0%', '0%'],
          }
        },
        {
          value: dataList[2],
          name: '月平均',
          title: {
            show: false,
            offsetCenter: ['0%', '30%'],
            fontSize: 13,
            borderWidth: 0,
            color: '#fff',
          },
          itemStyle: {
            color: '#accfff'
          },
          detail: {
            offsetCenter: ['0%', '30%'],
          }
        }
      ];
      let option = {
        title: {
          text: this.title,
          left: 'center',
          bottom: this.w960 ? '-6%' : '-3%',
          textStyle: {
            color: '#fff',
            fontSize: this.titleSize
          }
        },
        process: {
          clip: true
        },
        grid: {
          top: '0%',
          left: '3%',
          right: '8%',
          containLabel: true
        },
        tooltip: {
          // trigger: 'axis'
        },
        series: [
          {
            type: 'gauge',
            startAngle: 90,
            endAngle: -270,
            radius: this.w960 ? '85%' : '75%',
            pointer: {
              show: false
            },
            progress: {
              show: true,
              overlap: false,
              roundCap: true,
              clip: false,
              itemStyle: {
                borderWidth: 1,
                borderColor: '#464646'
              }
            },
            axisLine: {
              lineStyle: {
                width: 20,
                color: '#282c34'
              }
            },
            splitLine: {
              show: false,
              distance: 0,
              length: 10
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: false,
              distance: 50
            },
            data: gaugeData,
            title: {
              fontSize: 14
            },
            detail: {
              width: 30,
              height: 14,
              fontSize: this.screenWidth,
              color: 'inherit',
              borderColor: 'inherit',
              borderRadius: 20,
              borderWidth: 0,
              formatter: '{value}'
            }
          }
        ]
      }

      option && this.chart.setOption(option);

    }
  }
}
</script>

<style scoped lang="scss">
.chart {
  height: 100%;
}
</style>
